var controllerScrollPanel = new ScrollMagic.Controller();

module.exports = controllerScrollPanel;